import { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import './main-layout.styles.scss';
import CostingForm from '../costing/form/costing-form.component';
import CostingComponent from '../costing/costing-list.component';
import CostingDetailComponent from '../costing/detail/costing-detail.component';
import CustomerList from '../customer/customer-list.component';
import CustomerForm from '../customer/form/customer-form.component';
import CurrencyList from '../currency/currency-list.component';
import CurrencyForm from '../currency/form/currency-form.component';
import MasterDataForm from '../master-data/form/master-data-form.component';
import MasterDataList from '../master-data/master-data-list.component';
import SupplierForm from '../supplier/form/supplier-form.component';
import SupplierList from '../supplier/supplier-list.component';
import Logging from '../logging/logging.component';
import MasterDataPendingList from '../master-data/master-data-pending-list.component';
import ProductList from '../product/product-list.component';
import EnquiryForm from '../enquiry/form/enquiry-form.component';
import EnquiryList from '../enquiry/enquiry-list.component';
import OrderForm from '../order/form/order-form.component';
import OrderList from '../order/order-list.component';
import UserForm from '../user/create/form/user-form.component';
import UserList from '../user/create/user-list.component';
import CostingListComponent from '../costing/costing-page/costing-page.component';
import EnquiryOrderList from '../enquiry/order/enquiry-order-list.component';
import ProductionProcessList from '../production/process/production-process-list.component';
import ProductionProcessForm from '../production/process/form/production-process-form.component';
import OrderTaskList from '../task/order-task-list.component';
import EnquiryProductList from '../enquiry/product-list/enq-product-list.component';
import ScheduleForm from '../production/schedule/form/schedule-form.component';
import ScheduleList from '../production/schedule/schedule-list.component';
import OrderScheduleList from '../production/schedule/order-schedule/ord-sch-list.component';
import OrdPrdComponent from '../order/ord-prod/ord-prd.component';
import OrderPurchase from '../order/purchase/order-purchase.component';
import ProcessingData from '../order/processing-data/processing-data.component';
import POJOForm from '../order/pojo/pojo-form.component';
import POJOComponent from '../order/pojo/pojo.component';
import ChallanForm from '../order/challan/challan-form.component';
import ChallanComponent from '../order/challan/challan.component';
import StockList from '../order/stock/stock-list.component';
import StockLedger from '../order/stock/stock-ledger.component';
import AmazonInventory from '../amazon/inventory/inventory-list.component';
import AmazonSyncStatus from '../amazon/sync/sync-status.component';
import AmazonOrderPerf from '../amazon/performance/order-perf.component';
import AmazonAllOrder from '../amazon/order/all-order.component';
import AmazonParameter from '../amazon/parameter/parameter.component';
import AmazonCosting from '../amazon/costing/costing-list.component';
import AmazonTacos from '../amazon/tacos/tacos-list.component';
import { AppContext } from '../../app-context';
import React from 'react';
import AmazonSyncReport from '../amazon/sync/sync-report.component';
import AmazonAllProductSale from '../amazon/sale/all-product-sale.component';
import AmazonAllProductReturn from '../amazon/return/all-product-return.component';
import AmazonDailyOrder from '../amazon/order/daily-order.component';
import AmazonLog from '../amazon/log/log.component';
import AmazonTransaction from '../amazon/transaction/transaction.component';
import AmazonSalePerf from '../amazon/performance/sale-perf.component';
import AmazonProductMargin from '../amazon/sale/product-margin.component';
import AmazonAdSpendSku from '../amazon/tacos/ad-spend-sku-component';
import GeneralTaskList from '../task/general-task-list.component';
import MyTaskList from '../task/my-task-list.component';
import GeneralTaskForm from '../task/general-task-form.component';
import AmazonFee from '../amazon/fee/fee.component';
import PojoChallanComponent from '../order/pojo/pojo-challan.component';
import MergePojoComponent from '../order/pojo/merge-pojo.component';
import AmzVirtualProductList from '../amazon/virtual product/product-list.component';
import AmzVirtualProduct from '../amazon/virtual product/product-form.component';
import SaleChallan from '../order/challan/sale-challan.component';

export const RedirectToLogin: React.FC = () => {
  const navigate = useNavigate();
  const appContext = React.useContext(AppContext);
  useEffect(() => {
    const currUrl = window.location.href
    if(!currUrl.includes('/task/general/list')){
      if('LFHADMIN' === appContext.userData.role) {
        navigate('/amazon/perf/order');
      } else {
        navigate('/task/general/mytask');
      }
    }
  },[]);

  return null;
};
const MainRouter = () => {

  return (
    <div className="main-container">
      <Routes>
        <Route path={"/"} element={<RedirectToLogin />} />
        <Route path={"/costing/list"} element={<CostingComponent />} />
        <Route path={"/costing/list/:rowId"} element={<CostingForm />} />
        <Route path={"/costing/list/new"} element={<CostingForm />} />
        <Route path={"/costing-list/enq/:enquiryCode"} element={<CostingListComponent />} />
        <Route path={"/costing-list/prd/:enqProductId"} element={<CostingListComponent />} />
        <Route path={"/supplier/list"} element={<SupplierList />} />
        <Route path={"/supplier/list/:rowId"} element={<SupplierForm />} />
        <Route path={"/supplier/list/new"} element={<SupplierForm />} />
        <Route path={"/customer/list"} element={<CustomerList />} />
        <Route path={"/customer/list/:rowId"} element={<CustomerForm />} />
        <Route path={"/customer/list/new"} element={<CustomerForm />} />
        <Route path={"/user/list"} element={<UserList />} />
        <Route path={"/user/list/:rowId"} element={<UserForm />} />
        <Route path={"/user/list/new"} element={<UserForm />} />
        <Route path={"/task/order/list"} element={<OrderTaskList />} />
        <Route path={"/task/general/list"} element={<GeneralTaskList />} />
        <Route path={"/task/general/mytask"} element={<MyTaskList />} />
        <Route path={"/task/general/list/new"} element={<GeneralTaskForm/>} />
        <Route path={"/task/general/list/:rowId"} element={<GeneralTaskForm/>} />
        <Route path={"/enquiry/list"} element={<EnquiryList />} />
        <Route path={"/enquiry/list/:rowId"} element={<EnquiryForm />} />
        <Route path={"/enquiry/list/new"} element={<EnquiryForm />} />
        <Route path={"/enquiry/order/enq/:enquiryCode"} element={<EnquiryOrderList />} />
        <Route path={"/enquiry/order/cos/:costingCode"} element={<EnquiryOrderList />} />
        <Route path={"/enquiry/order/new"} element={<OrderForm />} />
        <Route path={"/enquiry/order/:rowId"} element={<OrderForm />} />
        <Route path={"/enquiry/product/list/:enquiryId"} element={<EnquiryProductList />} />
        <Route path={"/order/list"} element={<OrderList />} />
        <Route path={"/order/purchase/:orderId"} element={<OrderPurchase />} />
        <Route path={"/order/processing/:orderId"} element={<ProcessingData />} />
        <Route path={"/order/product/:orderId"} element={<OrdPrdComponent />} />
        <Route path={"/order/pojo/:pojoId"} element={<POJOForm />} />
        <Route path={"/order/pojo/list/:linkId"} element={<POJOComponent />} />
        <Route path={"/order/pojo/new"} element={<POJOForm />} />
        <Route path={"/order/challan/:challanId"} element={<ChallanForm />} />
        <Route path={"/order/challan/list/:pojoId"} element={<ChallanComponent />} />
        <Route path={"/order/challan/sale/:orderId"} element={<SaleChallan />} />
        <Route path={"/challan/list"} element={<ChallanComponent />} />
        <Route path={"/pojo/list"} element={<PojoChallanComponent />} />
        <Route path={"/pojo/merge/:orderId"} element={<MergePojoComponent />} />
        <Route path={"/order/challan/new"} element={<ChallanForm />} />
        <Route path={"/stock/list/"} element={<StockList />} />
        <Route path={"/stock/ledger/"} element={<StockLedger />} />
        <Route path={"/product/:enqPrdId/order"} element={<OrdPrdComponent />} />
        <Route path={"/production/schedule/:orderCode/list"} element={<OrderScheduleList />} />
        <Route path={"/production/schedule/list"} element={<ScheduleList />} />
        <Route path={"/production/schedule/new"} element={<ScheduleForm />} />
        <Route path={"/production/schedule/:rowId"} element={<ScheduleForm />} />
        <Route path={"/production/process/list"} element={<ProductionProcessList />} />
        <Route path={"/production/process/list/:rowId"} element={<ProductionProcessForm />} />
        <Route path={"/production/process/list/new"} element={<ProductionProcessForm />} /> 
        <Route path={"/costing-detail"} element={<CostingDetailComponent />} />
        <Route path={"/master-data/list"} element={<MasterDataList />} />
        <Route path={"/master-data/list/:rowId"} element={<MasterDataForm />} />
        <Route path={"/master-data/list/new"} element={<MasterDataForm />} />
        <Route path={"/master-data/"} element={<MasterDataForm />} />
        <Route path={"/master-data-pending/list"} element={<MasterDataPendingList/>} />
        <Route path={"/currency/list"} element={<CurrencyList />} />
        <Route path={"/currency/list/:currency"} element={<CurrencyForm />} />
        <Route path={"/currency/list/new"} element={<CurrencyForm />} />
        <Route path={"/logging/list"} element={<Logging />} />
        <Route path={"/products/list"} element={<ProductList />} />
        <Route path={"/amazon/inventory"} element={<AmazonInventory />} />
        <Route path={"/amazon/perf/order"} element={<AmazonOrderPerf />} />
        <Route path={"/amazon/perf/sale"} element={<AmazonSalePerf />} />
        <Route path={"/amazon/allorder"} element={<AmazonAllOrder />} />
        <Route path={"/amazon/virtualproduct"} element={<AmzVirtualProductList />} />
        <Route path={"/amazon/virtualproduct/new"} element={<AmzVirtualProduct />} />
        <Route path={"/amazon/virtualproduct/:rowId"} element={<AmzVirtualProduct />} />
        <Route path={"/amazon/parameter"} element={<AmazonParameter />} />
        <Route path={"/amazon/prdcosting"} element={<AmazonCosting />} />
        <Route path={"/amazon/fee"} element={<AmazonFee/>} />
        <Route path={"amazon/tacos"} element={<AmazonTacos />} />
        <Route path={"amazon/adspendsku"} element={<AmazonAdSpendSku />} />
        <Route path={"/amazon/syncstatus"} element={<AmazonSyncStatus />} />
        <Route path={"amazon/syncreport"} element={<AmazonSyncReport />} />
        <Route path={"amazon/productsale"} element={<AmazonAllProductSale />} />
        <Route path={"amazon/productmargin"} element={<AmazonProductMargin />} />
        <Route path={"amazon/dailyorder"} element={<AmazonDailyOrder />} />
        <Route path={"amazon/return"} element={<AmazonAllProductReturn />} />
        <Route path={"amazon/log"} element={<AmazonLog />} />
        <Route path={"amazon/transaction"} element={<AmazonTransaction />} />
      </Routes>
    </div >
  );
}

export default MainRouter;
